import api from './api';

export const getDailyWheelConfig = () => api.get('/user-quests/daily-quest/wheel');
